import { doc, where, writeBatch } from 'firebase/firestore'
import { createRefPath } from 'global/firestoreData/appData/appRefPaths'
import _ from 'lodash'
import { useContext, useEffect, useState } from 'react'
import { ParentContext } from '../../cnr/contexts/ParentContext'
import Wrapper, { wrapperTypes } from '../../wrappers/Wrapper'
import WrapperVertCols from '../../wrappers/WrapperVertCols'
import UiSaveButtons from '../buttons/UiSaveButtons'
import MenuVert from '../menus/MenuVert'

const _allowDelete = true

const AppErrors = () => {

  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {}
  const { app_state, paps_state } = states
  const { database_fns } = fns
  const { pathViews } = paps_state ?? {}
  const { mainDb } = app_state ?? {}

  const [currentErrors, setCurrentErrors] = useState([])
  const [currentError, setCurrentError] = useState({})

  useEffect(() => {
    const cb = (data) => {
      if (data) {
        const _errors = {}
        _.forEach(data, (dataItem, dataItemKey) => {
          _errors[dataItemKey] = {
            name: dataItem?.message,
            firstStackLine: dataItem?.firstStackLine,
            secondStackLine: dataItem?.secondStackLine,
            timestamp: dataItem?.timestamp
          }
        })
        setCurrentErrors(_errors)
      }
    }
    const refPath = createRefPath(['_errorBoundry'])
    const wheres = []
    wheres.push(where('pathViews.events', "==", pathViews.events))
    database_fns.get_data({ refPath, callback: cb, wheres })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelect_currentError = (item) => setCurrentError(item)

  const deleteAllPromise = async () => {
    const batchInfos = []
    const batch = writeBatch(mainDb);
    _.forEach(currentErrors, (currentError, key) => {
      const refPath = createRefPath(['_errorBoundry', key])
      const doc_ref = doc(mainDb, refPath)
      batchInfos.push({ refPath })
      batch.delete(doc_ref);
    })
    if (_allowDelete) {
      await batch.commit();
    }
  }

  const handleDeleteAll = () => {
    if (currentErrors) {
      deleteAllPromise()
    }
  }

  const wrapper_error = () => <Wrapper
    header={currentError?.name || 'None Selected'}
    content={<div style={{ padding: '1em', display: 'flex', flexDirection: 'column', gap: '.5em' }}>
      <div>{currentError?.name || ''}</div>
      <div>{currentError?.firstStackLine || ''}</div>
      <div>{currentError?.secondStackLine || ''}</div>
      <div>{currentError?.timestamp || ''}</div>
    </div>}
    wrapperType={wrapperTypes.padded}
  ></Wrapper>

  const menu_vert_errors = () => <MenuVert
    menuItems={_.sortBy(currentErrors)}
    oc={handleSelect_currentError}
    activeMenuItem={currentError}
    header={`Errors: ${_.size(currentErrors)}`}
  />

  const content = () => <WrapperVertCols mvc={'1-3'}>
    {menu_vert_errors()}
    {wrapper_error()}
  </WrapperVertCols >

  const wrapper_all = () => <Wrapper
    content={content()}
    wrapperType={wrapperTypes.paddedFooter}
    footer={<UiSaveButtons delete={{ caption: 'Remove All', oc: handleDeleteAll }} />}
  ></Wrapper>

  return wrapper_all()

}

export default AppErrors
